import React, { FC } from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Input } from "antd";
import { INotification } from "interfaces";
import JoditEditor from "jodit-react";

export const NotificationEdit: FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm<INotification>({});

  return (
    <Edit title={"Sửa thông báo"} saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Tiêu đề"
          name="title"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Nội dung"
          name="content"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.TextArea maxLength={1000} />
        </Form.Item>
        <Form.Item
          label="Chi tiết"
          name="detail"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <JoditEditor value={""} />
        </Form.Item>
        <Form.Item
          label="Link"
          name="link"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
